import { BrowserRouter, Route, Routes } from 'react-router-dom';
import {AuthProvider} from './contexts/auth';
import Cards from './pages/cards/cards';
import IndexRoutes from './routes/indexRoutes'

function App() {
  return (
    <AuthProvider>
      <div style={{width: "100vw", height: "100vh", margin: "0px", display: "grid"}}>
        <IndexRoutes />
      </div>
    </AuthProvider> 
  );
}

export default App;
